var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 19.3125C5.625 18.3984 6.32812 17.625 7.3125 17.625C8.22656 17.625 9 18.3984 9 19.3125C9 20.2969 8.22656 21 7.3125 21C6.32812 21 5.625 20.2969 5.625 19.3125ZM30.375 19.3125C30.375 20.2969 29.6016 21 28.6875 21C27.7031 21 27 20.2969 27 19.3125C27 18.3984 27.7031 17.625 28.6875 17.625C29.6016 17.625 30.375 18.3984 30.375 19.3125ZM3.375 12.9141L5.76562 4.82812C6.53906 2.4375 8.71875 0.75 11.1797 0.75H24.75C27.2109 0.75 29.3906 2.4375 30.1641 4.82812L32.5547 12.9141C34.5938 14.1094 36 16.2891 36 18.75V31.125C36 31.7578 35.4375 32.25 34.875 32.25C34.2422 32.25 33.75 31.7578 33.75 31.125V27.75H2.25V31.125C2.25 31.7578 1.6875 32.25 1.125 32.25C0.492188 32.25 0 31.7578 0 31.125V18.75C0 16.2891 1.33594 14.1094 3.375 12.9141ZM5.97656 12.0703C6.1875 12.0703 6.46875 12 6.75 12H29.25C29.4609 12 29.7422 12.0703 29.9531 12.0703L27.9844 5.46094C27.5625 3.98438 26.2266 3 24.75 3H11.1797C9.70312 3 8.36719 3.98438 7.94531 5.46094L5.97656 12.0703ZM2.25 18.75V25.5H33.75V18.75C33.75 16.8516 32.4844 15.1641 30.7266 14.5312C30.2344 14.3906 29.7422 14.25 29.25 14.25H6.75C6.1875 14.25 5.69531 14.3906 5.20312 14.5312C3.44531 15.1641 2.25 16.8516 2.25 18.75Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.afeae42027b22ea9d93b280951e1c187.svg";
export { ForwardRef as ReactComponent };